import { createApp } from 'vue'
import Toaster from "@meforma/vue-toaster";
import App from './App.vue'
import './assets/tailwind.css'

window.core = window.core || {};
window.core.lang = document.cookie.includes("lang=ar") ? "ar" : "en";


createApp(App)
    .use(Toaster)
    .mount('#app')
